// removed by extract-text-webpack-plugin
module.exports = {"root":"_22V4AdhEPTb5ZkBTqfppBj","navigation":"_2XN313_XPfMvsyabEciFkU","logout":"H7nmCGNr7udofR6tmIzAN","active":"d7UppZWW6bZ5KtoQPgN_C"};


//////////////////
// WEBPACK FOOTER
// ./src/components/account/layout.scss
// module id = 1679
// module chunks = 0